<template>
  <!-- 从期刊服务模块中的四个小模块进入此页 -->
  <div id="all">
    <Header :pageTitle="title" />
    <div class="header">
      <img src="@/assets/img/details/mx.png" alt="" />
    </div>
    <div class="middle">
      <div class="pachytene"></div>
      <div class="backdrop">
        <div class="h">
          <div class="left"></div>
          <div class="ball"></div>
          <div class="title">享多重福利</div>
          <div class="ball"></div>
          <div class="right"></div>
        </div>
        <ul>
          <li>
            <img src="@/assets/img/details/floor.png" alt="" />
            <div class="minImg">
              <img src="@/assets/img/details/bao.png" alt="" />
            </div>
            <div v-if="type == 1" class="introduce">
              百科在线是中文知识网旗下产品，收录精品学术期刊
            </div>
            <div v-if="type == 2" class="introduce">
              采编征稿件的实用工具，方便转发推广
            </div>
            <div v-if="type == 3" class="introduce">审校流程自定义</div>
            <div v-if="type == 4" class="introduce">为期刊建设门户网站</div>
          </li>
          <li>
            <img src="@/assets/img/details/floor.png" alt="" />
            <div class="minImg">
              <img src="@/assets/img/details/bao.png" alt="" />
            </div>
            <div v-if="type == 1" class="introduce">为期刊引流海量优质稿源</div>
            <div v-if="type == 2" class="introduce">期刊介绍和精品文献推荐</div>
            <div v-if="type == 3" class="introduce">
              个性化的成员用户权限配置
            </div>
            <div v-if="type == 4" class="introduce">通知公告发布</div>
          </li>
          <li>
            <img src="@/assets/img/details/floor.png" alt="" />
            <div class="minImg">
              <img src="@/assets/img/details/bao.png" alt="" />
            </div>
            <div v-if="type == 1" class="introduce">建立期刊自有文献数据库</div>
            <div v-if="type == 2" class="introduce">稿件状态跟踪查询</div>
            <div v-if="type == 3" class="introduce">
              无需频繁下载上传,在线完成编审工作
            </div>
            <div v-if="type == 4" class="introduce">过刊数据浏览</div>
          </li>
          <li>
            <img src="@/assets/img/details/floor.png" alt="" />
            <div class="minImg">
              <img src="@/assets/img/details/bao.png" alt="" />
            </div>
            <div v-if="type == 1" class="introduce">
              依托中文知识网生态体系,推广传播期刊论文
            </div>
            <div v-if="type == 2" class="introduce">
              稿件关联采编，便于工作绩效统计
            </div>
            <div v-if="type == 3" class="introduce">
              费用扫码在线支付,银联结算自动划付到指定账户
            </div>
            <div v-if="type == 4" class="introduce">投稿入口</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="floor">
      <div class="pachytene"></div>
      <div class="backdrop">
        <div class="h">
          <div class="left"></div>
          <div class="ball"></div>
          <div class="title">诚邀加入</div>
          <div class="ball"></div>
          <div class="right"></div>
        </div>
        <ul class="ipt">
          <li :style="{ marginBottom: errorOne == null ? '10px' : 0 }">
            <input
              :class="{ ErrorInput: errorOne !== null }"
              v-model="form.compellation"
              placeholder="姓名"
              type="text"
            />
            <div class="Error" v-if="errorOne == 1">不能为空</div>
            <div class="Error" v-if="errorOne == 2">不能大于10个字符</div>
            <div class="Error" v-if="errorOne == 3">格式错误</div>
          </li>
          <li :style="{ marginBottom: errorTwo == null ? '10px' : 0 }">
            <input
              :class="{ ErrorInput: errorTwo !== null }"
              v-model="form.Phone"
              placeholder="联系电话"
              type="text"
            />
            <div class="Error" v-if="errorTwo == 1">不能为空</div>
            <div class="Error" v-if="errorTwo == 2">手机号格式错误</div>
          </li>
          <li :style="{ marginBottom: errorThree == null ? '10px' : 0 }">
            <input
              :class="{ ErrorInput: errorThree !== null }"
              v-model="form.designation"
              placeholder="期刊名称"
              type="text"
            />
            <div class="Error" v-if="errorThree == 1">不能为空</div>
            <div class="Error" v-if="errorThree == 2">不能大于30个字符</div>
            <div class="Error" v-if="errorThree == 3">格式错误</div>
          </li>
        </ul>
        <div @click="applyFor(form)" class="but">
          <span>加入申请</span>
        </div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div @click="show = false" class="top">
            <img src="@/assets/img/details/close.png" alt="" />
          </div>
          <div class="middle">
            <img src="@/assets/img/details/chenggong.png" alt="" />
            <ul>
              <li>申请提交成功</li>
              <li>工作人员会尽快联系你,</li>
              <li>请保持电话畅通</li>
            </ul>
          </div>
          <div @click="getBack" class="bottom">返回期刊服务</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Overlay } from "vant";
import Header from "@/views/mobileView/components/header";
export default {
  name: "JournalOfPromotion",
  components: {
    Header,
    "van-overlay": Overlay,
  },
  data() {
    return {
      show: false,
      title: "",
      type: this.$route.query.pageType, // 判断当前是什么类型
      form: {
        // 收集数据
        compellation: "", // 姓名
        Phone: "", // 手机号
        designation: "", // 期刊名称
      },
      errorOne: null,
      errorTwo: null,
      errorThree: null,
    };
  },
  computed: {},
  watch: {
    // 控制是否可滑动屏幕
    show() {
      if (this.show) {
        document
          .querySelector("body")
          .setAttribute("style", "overflow: hidden");
      } else {
        document.querySelector("body").setAttribute("style", "overflow: none");
      }
    },
  },
  created() {
    this.title = this.$route.query.title;
    // this.type = this.$route.query.pageType;
  },
  mounted() {},
  methods: {
    // 加入申请
    async applyFor(form) {
      // 验证三个表单
      if (form.compellation == "") {
        this.errorOne = 1;
      } else if (form.compellation.length > 10) {
        this.errorOne = 2;
      } else if (!/^[^0-9０-９]+$/g.test(form.compellation)) {
        this.errorOne = 3;
      } else {
        this.errorOne = null;
      }
      if (form.Phone == "") {
        this.errorTwo = 1;
      } else if (
        !/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/.test(
          form.Phone
        )
      ) {
        this.errorTwo = 2;
      } else {
        this.errorTwo = null;
      }
      if (form.designation == "") {
        this.errorThree = 1;
      } else if (form.designation.length > 30) {
        this.errorThree = 2;
      } else if (!/^[^0-9０-９]+$/g.test(form.designation)) {
        this.errorThree = 3;
      } else {
        this.errorThree = null;
      }
      if (
        this.errorOne == null &&
        this.errorTwo == null &&
        this.errorThree == null
      ) {
        // 准备参数
        let obj = {
          companyName: form.designation,
          name: form.compellation,
          tel: form.Phone,
          type: this.$route.query.pageType,
        };
        this.CooperationInvitation(obj);
      }
    },
    // 合作邀约接口调用
    async CooperationInvitation(data) {
      let resp = await this.$apis.mainServe.CooperationInvitation(data);
      if (resp.resultCode == 200) {
        this.form.compellation = "";
        this.form.Phone = "";
        this.form.designation = "";
        this.show = true;
      }
    },
    // 返回期刊服务
    getBack() {
      this.$router.push("/periodicalService");
      document.querySelector("body").setAttribute("style", "overflow: none");
    },
  },
};
</script>

<style scoped lang="scss">
#all {
  width: 100%;
  height: 100%;
  background: #507cff;
  margin-top: 44px;
  & .header {
    width: 100%;
    & img {
      width: 100%;
    }
  }
  & .middle {
    & .pachytene {
      width: 95%;
      height: 9px;
      background: #373cd6;
      margin: 0 auto;
      border-radius: 5px;
    }
    & .backdrop {
      width: 92%;
      height: 500px;
      background: #fff;
      margin: 0 auto;
      padding-top: 20px;
      & .h {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        & .left {
          width: 40px;
          height: 1px;
          background: #ff733e;
        }
        & .title {
          font-size: 18px;
          text-align: center;
          font-weight: 600;
          letter-spacing: 2px;
          font-style: oblique;
        }
        & .right {
          width: 40px;
          height: 1px;
          background: #ff733e;
        }
        & .ball {
          width: 8px;
          height: 8px;
          border-radius: 50px;
          background: #ff733e;
          margin: 0 10px;
        }
      }
      & ul {
        & li {
          text-align: center;
          padding: 0 14px;
          margin-bottom: 20px;
          height: 90px;
          & img {
            width: 100%;
            height: 90px;
          }
          & .minImg {
            width: 50px;
            height: 50px;
            border-radius: 50px;
            position: relative;
            top: 5px;
            left: 20px;
            margin-top: -80px;
            & img {
              width: 50px;
              height: 50px;
            }
          }
          & .introduce {
            width: 70%;
            font-size: 15px;
            color: #fff;
            text-align: left;
            position: relative;
            float: right;
            top: -40px;
            right: 10px;
          }
        }
      }
    }
  }
  & .floor {
    border-bottom: 15px solid #507cff;
    & .pachytene {
      width: 95%;
      height: 9px;
      background: #373cd6;
      margin: 0 auto;
      margin-top: 10px;
      border-radius: 5px;
    }
    & .backdrop {
      width: 92%;
      height: 300px;
      background: #fff;
      margin: 0 auto;
      padding-top: 20px;
      & .h {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        & .left {
          width: 40px;
          height: 1px;
          background: #ff733e;
        }
        & .title {
          font-size: 18px;
          text-align: center;
          font-weight: 600;
          letter-spacing: 2px;
          font-style: oblique;
        }
        & .right {
          width: 40px;
          height: 1px;
          background: #ff733e;
        }
        & .ball {
          width: 8px;
          height: 8px;
          border-radius: 50px;
          background: #ff733e;
          margin: 0 10px;
        }
      }
    }
    & .ipt {
      text-align: center;
      & .Error {
        font-size: 12px;
        color: #ff733e;
      }
      & input {
        width: 60%;
        height: 35px;
        border-radius: 10px;
        border: 1px solid #507cff77;
        padding: 0 20px;
      }
    }
    & .but {
      width: 58%;
      height: 35px;
      background: #507cff;
      text-align: center;
      line-height: 35px;
      margin: 0 auto;
      color: #fff;
      border-radius: 8px;
      margin-top: 30px;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 235px;
  height: 317px;
  background-color: #fff;
  & .top {
    width: 20px;
    height: 20px;
    position: relative;
    top: 10px;
    left: 205px;
    & img {
      width: 20px;
      height: 20px;
    }
  }
  & .middle {
    margin-top: 20px;
    text-align: center;
    & img {
      width: 70px;
      height: 70px;
      margin-bottom: 20px;
    }
  }
  & .bottom {
    width: 200px;
    height: 30px;
    background: #536dfe;
    color: #fff;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
    position: relative;
    bottom: -70px;
    border-radius: 20px;
  }
}
.ErrorInput {
  border: 1px solid #ff733e !important;
}
</style>
